import { render, staticRenderFns } from "./servicee.vue?vue&type=template&id=c6723a42&scoped=true&"
import script from "./servicee.vue?vue&type=script&lang=js&"
export * from "./servicee.vue?vue&type=script&lang=js&"
import style0 from "./servicee.vue?vue&type=style&index=0&id=c6723a42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6723a42",
  null
  
)

export default component.exports